import styled from 'styled-components'

export const NotificationTextStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
`
